import axios from "axios";
import { sendMultipartFilePost } from "../utils/multipart-helper";

const requestQuestionRegist = question => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/landing/question/regist`,
    question
  );
};

const requestQnaList = param => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/admin/landing/question/qna-page`,
    param
  );
};

export { requestQuestionRegist, requestQnaList };
